import { MyVideosScreen } from 'modules/coaching/screens/MyVideosScreen'

export const MyVideosPage = () => {
  /* --- Section 6: Render --- */
  return <MyVideosScreen />
}
